import {hitAlgolytics} from "@pg-mono/algolytics";

import {ViewType} from "../../view_type/ViewType";
import {IApplicationAdditionalQuestionTypes} from "../types/form/IApplicationFormAdditionalQuestionTypes";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";

export interface IApplicationAnalyticsData {
    offer_id?: number;
    source_id: ApplicationSource;
    source_section: ApplicationSourceSection;
    view_type: ViewType | null;
    property_id?: number;
}

export function sendApplicationHit(
    selectedQuestions: IApplicationAdditionalQuestionTypes[],
    name: string,
    phone: string,
    email: string,
    analyticsData: IApplicationAnalyticsData,
    generatedMessage: string,
    modifiedMessage?: string
) {
    let eventData = null;
    if (generatedMessage && modifiedMessage) {
        eventData = {
            event_type: "click_send",
            questions: selectedQuestions.map((selectedQuestion) => getQuestionOrder(selectedQuestion)),
            name,
            phone,
            email,
            generated_message: generatedMessage,
            modified_message: modifiedMessage
        };
    } else {
        eventData = {
            event_type: "click_send",
            questions: selectedQuestions.map((selectedQuestion) => getQuestionOrder(selectedQuestion)),
            name,
            phone,
            email,
            generated_message: generatedMessage
        };
    }

    hitAlgolytics("form_with_questions_click_send", {
        ...eventData,
        ...analyticsData
    });
}

//  Utils
function getQuestionOrder(question: IApplicationAdditionalQuestionTypes) {
    const questionsOrder: {[key in IApplicationAdditionalQuestionTypes]: number} = {
        price: 1,
        parkAndStorage: 2,
        rent: 3,
        payPlan: 4,
        areaInfr: 5,
        similarApts: 6,
        heatingType: 7,
        gardenSize: 8
    };

    return questionsOrder[question];
}
import {hitAlgolytics} from "@pg-mono/algolytics";

import {ViewType} from "../../view_type/ViewType";
import {IApplicationAdditionalQuestionTypes} from "../types/form/IApplicationFormAdditionalQuestionTypes";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";

export interface IApplicationAnalyticsData {
    offer_id?: number;
    source_id: ApplicationSource;
    source_section: ApplicationSourceSection;
    view_type: ViewType | null;
    property_id?: number;
}

export function sendApplicationHit(
    selectedQuestions: IApplicationAdditionalQuestionTypes[],
    name: string,
    phone: string,
    email: string,
    analyticsData: IApplicationAnalyticsData,
    generatedMessage: string,
    modifiedMessage?: string
) {
    let eventData = null;
    if (generatedMessage && modifiedMessage) {
        eventData = {
            event_type: "click_send",
            questions: selectedQuestions.map((selectedQuestion) => getQuestionOrder(selectedQuestion)),
            name,
            phone,
            email,
            generated_message: generatedMessage,
            modified_message: modifiedMessage
        };
    } else {
        eventData = {
            event_type: "click_send",
            questions: selectedQuestions.map((selectedQuestion) => getQuestionOrder(selectedQuestion)),
            name,
            phone,
            email,
            generated_message: generatedMessage
        };
    }

    hitAlgolytics("form_with_questions_click_send", {
        ...eventData,
        ...analyticsData
    });
}

//  Utils
function getQuestionOrder(question: IApplicationAdditionalQuestionTypes) {
    const questionsOrder: {[key in IApplicationAdditionalQuestionTypes]: number} = {
        price: 1,
        parkAndStorage: 2,
        rent: 3,
        payPlan: 4,
        areaInfr: 5,
        similarApts: 6,
        heatingType: 7,
        gardenSize: 8
    };

    return questionsOrder[question];
}
